import React from 'react'
import useForm from '../../hooks/useForm';
import validation from '../../hooks/validation';



function EmployeeLogin({ submitForm }) {
    const { handleChange, handleSubmit, values, errors } = useForm(
        submitForm,
        validation
    );

    return (
        <div className="tab-pane fade" id="pills-employee" role="tabpanel" aria-labelledby="pills-employee-tab">
            <form onSubmit={handleSubmit}>
                <div>
                    <label>User Name</label>
                    <input className='form-control' type="email" name="email" placeholder="Enter Your Email" value={values.email}
                        onChange={handleChange} />
                    {errors.email && <p className="form-error ">{errors.email}</p>}
                    <label className='mt-3'>Password</label>
                    <input className='form-control' type="password" name="password" id="password" placeholder="Enter Your Password" value={values.password}
                        onChange={handleChange} />
                    {errors.password && <p className="form-error ">{errors.password}</p>}
                    <span className="fa fa-fw fa-eye field-icon" id="eye"></span>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div class="form-group mt-2">
                            <input type="checkbox" id="customCheck1" checked />
                            <label for="customCheck1">Remember Password</label>
                        </div>
                        {/* <div className="custom-control custom-checkbox custom-checkbox-blue mt-3">
                        <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck1" />
                        <label className="custom-control-label pt-1" for="customCheck1">Remember Password</label>
                    </div> */}
                    </div>
                    <div className='d-flex justify-content-between align-items-end'>
                        <div>
                            <button className='btn forgot-password-btn'>Forgot password?</button>
                        </div>
                        <div>
                            <button type="submit" className='btn mt-2'>Login</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default EmployeeLogin